import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

export default function Breadcrumb({item1, item2}) {  // Add item1 and item2 as props
  const defaultBreadcrumb = {
    title: 'Home',
    path: '/',
  };

  const breadcrumbs = [
    <RouterLink 
      key="1" 
      to={defaultBreadcrumb.path}
      className={`
        text-gray-500
        hover:text-theme-blue
        transition-colors 
        duration-300
        text-xs sm:text-sm md:text-base lg:text-base
        flex 
        items-center
      `}
    >
      {defaultBreadcrumb.title}
    </RouterLink>,
    <Typography
      key="2"
      sx={{
        color: 'text-gray',
        fontSize: {
          xs: '0.75rem',
          sm: '0.87rem',
          md: '1rem',
          lg: '1rem'
        },
        display: 'flex',
        alignItems: 'center'  
      }}
    >
      {item1}
    </Typography>,
    <Typography
      key="3"
      sx={{
        color: '#347c84', 
        fontSize: {
          xs: '0.75rem',
          sm: '0.87rem',
          md: '1rem',
          lg: '1rem'
        },
        display: 'flex',
        alignItems: 'center'  
      }}
    >
      {item2}
    </Typography>,
  ];

  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon 
          sx={{ 
            fontSize: {
              xs: '0.8rem',
              sm: '0.9rem',
              md: '1rem',
              lg: '1rem'
            }
          }}
        />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}